var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99933 4.567C9.24053 4.567 10.2467 3.54464 10.2467 2.2835C10.2467 1.02236 9.24053 0 7.99933 0C6.75814 0 5.75195 1.02236 5.75195 2.2835C5.75195 3.54464 6.75814 4.567 7.99933 4.567Z",
    fill: "#538FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.195 5.80297C10.8931 5.5644 10.5325 5.40251 10.1384 5.35991C10.0545 5.35139 5.94549 5.35139 5.87002 5.35991C5.46751 5.40251 5.10692 5.55588 4.80503 5.80297C4.34382 6.16936 4.04193 6.72319 4 7.35371V12.9176C4 13.3522 4.33543 13.7015 4.75472 13.7015C5.174 13.7015 5.52621 13.3607 5.52621 12.9261V7.88198C5.52621 7.78826 5.61006 7.71157 5.69392 7.71157C5.77778 7.71157 5.86164 7.78826 5.86164 7.88198L5.84486 21.0121C5.84486 21.5574 6.27254 22.0005 6.80922 22.0005C7.34591 22.0005 7.77359 21.5659 7.77359 21.0206L7.79036 14.4428C7.79036 14.3235 7.8826 14.2383 7.99161 14.2383C8.10063 14.2383 8.19287 14.332 8.19287 14.4428L8.1761 21.0121C8.1761 21.5574 8.60377 22.0005 9.14046 22.0005C9.67715 22.0005 10.1048 21.5659 10.1048 21.0206V14.5876L10.1132 7.88198C10.1132 7.78826 10.1887 7.71157 10.2809 7.71157C10.3732 7.71157 10.4486 7.78826 10.4486 7.88198V12.9176C10.4403 13.3522 10.7841 13.7015 11.2117 13.7015C11.6394 13.7015 11.9748 13.3607 11.9748 12.9261L11.9916 8.25688V7.43891C11.9832 6.77431 11.6646 6.1864 11.1866 5.80297H11.195Z",
    fill: "#538FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1508",
    d: "M1 21H4M12 21H15",
    stroke: "#538FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandIcon);
export default __webpack_public_path__ + "static/media/StandIcon.aedd08e5.svg";
export { ForwardRef as ReactComponent };